// extracted by mini-css-extract-plugin
export var wrapper = "ShineHover-module--wrapper--RHv36";
export var shine = "ShineHover-module--shine--Td1d7";